import { useState, useEffect } from 'react'
import { NavBar, List, Cell, Tag, Empty, Loading, Tabs } from 'react-vant'
import { ArrowLeft, BullhornO, InfoO, FireO, Contact } from '@react-vant/icons'
import { useNavigate } from 'react-router-dom'
import request from '../../api/request'

export default function NotificationList() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [notifications, setNotifications] = useState([])
    const [activeTab, setActiveTab] = useState('all')

    const fetchData = async () => {
        setLoading(true)
        try {
            const res = await request.get('/notifications/')
            setNotifications(res.items || [])
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    const getIcon = (type) => {
        switch (type) {
            case 'system': return <BullhornO color="#056b4f" />
            case 'academic': return <InfoO color="#00b578" />
            case 'sports': return <FireO color="#e11d48" />
            case 'personal': return <Contact color="#d97706" />
            default: return <BullhornO />
        }
    }

    const filteredNotifications = activeTab === 'all'
        ? notifications
        : notifications.filter(n => n.type === activeTab)

    return (
        <div className="notification-page" style={{ background: '#f8fafc', minHeight: '100vh' }}>
            <NavBar
                title="我的消息"
                leftArrow={<ArrowLeft />}
                onClickLeft={() => navigate(-1)}
                fixed
                placeholder
            />

            <Tabs active={activeTab} onChange={setActiveTab} sticky offsetTop={46}>
                <Tabs.TabPane name="all" title="全部" />
                <Tabs.TabPane name="system" title="系统" />
                <Tabs.TabPane name="academic" title="教学" />
                <Tabs.TabPane name="sports" title="体育" />
            </Tabs>

            <div style={{ padding: '12px 0' }}>
                {loading ? (
                    <div style={{ textAlign: 'center', padding: 50 }}><Loading type="spinner" /></div>
                ) : filteredNotifications.length > 0 ? (
                    <List>
                        {filteredNotifications.map(item => (
                            <Cell
                                key={item.id}
                                title={item.title}
                                label={item.content.length > 30 ? item.content.substring(0, 30) + '...' : item.content}
                                icon={getIcon(item.type)}
                                extra={<span style={{ fontSize: 12, color: '#94a3b8' }}>{new Date(item.created_at).toLocaleDateString()}</span>}
                                style={{ borderRadius: 8, margin: '0 12px 12px' }}
                            />
                        ))}
                    </List>
                ) : (
                    <Empty description="暂无消息通知" />
                )}
            </div>
        </div>
    )
}
